export default class Constants {
    static readonly MOBILE_VIEW_MAX_WIDTH = 1119;

    static readonly SEARCH_DEBOUNCE_MS = 200;

    static readonly LANGUAGE_STORAGE_KEY = 'selectedLanguage';

    static readonly API_BASE_URL =
        typeof import.meta !== 'undefined' &&
        import.meta.env &&
        import.meta.env.MODE === 'development'
            ? 'https://localhost:5144/api/'
            : 'https://teacher-api.paradigmmath.com/api/';
    static readonly CLASSROOM_BASE_URL =
        typeof import.meta !== 'undefined' &&
        import.meta.env &&
        import.meta.env.MODE === 'development'
            ? 'https://localhost:5143/api/'
            : 'https://classroom-api.paradigmmath.com/api/';

    static readonly USER_TYPE_MASTER_IDS = {
        SUPER_ADMIN: 1,
        TEACHER: 2,
        STUDENT: 3,
        DISTRICT_ADMIN: 4,
        SCHOOL_ADMIN: 5,
    };

    static readonly ROLES = {
        SUPER_ADMIN: 'Super Admin',
        DISTRICT_ADMIN: 'District Admin',
        SCHOOL_ADMIN: 'School Admin',
        TEACHER: 'Teacher',
        STUDENT: 'Student',
    };

    static readonly ALL_ROLES = [
        Constants.ROLES.SUPER_ADMIN,
        Constants.ROLES.DISTRICT_ADMIN,
        Constants.ROLES.SCHOOL_ADMIN,
        Constants.ROLES.TEACHER,
        Constants.ROLES.STUDENT,
    ];

    static readonly LANGUAGE_OPTIONS = {
        EN: 'English',
        ES: 'Spanish',
    };

    // Grades that have Spanish (ES) translations available
    static readonly ALLOWED_ES_GRADES = ['TK', 'K', '1', '2', '3', '4', '5', '6', '6M', '7', '8'];
}
